// ABOUTME: The seven yyyy-MM-dd strings of the ISO week a date falls in
// ABOUTME: Lives in model/ because both the calendar week and the workout forms ask for it

import { addDays, format, parseISO, startOfISOWeek } from "date-fns"

export function getWeekDates(weekStartDay: Date) {
  const startWeek = startOfISOWeek(weekStartDay)
  const days: string[] = []

  for (let i = 0; i < 7; i++) {
    days.push(format(addDays(startWeek, i), "yyyy-MM-dd"))
  }

  return days
}

/** The week of a yyyy-MM-dd date, Monday first — the `dates` the week's calendar query is keyed by. */
export const getDaysOfWeekStartingMonday = (date: string) => getWeekDates(startOfISOWeek(parseISO(date)))
